
import { isDevMode } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';

export type ILogLevel = 'error' | 'warn' | 'info';

interface ILoggerOptions {
  devOnly?: boolean;
  onceOnly?: boolean;
  withStack?: boolean;
  prefix?: string;
}

export class Logger {
  record: Record<string, boolean> = {};
  devOnly = false;
  onceOnly = false;
  withStack = false;
  prefix = '';
  constructor(
    options?: ILoggerOptions
  ) {
    this.devOnly = options?.devOnly ?? false;
    this.onceOnly = options?.onceOnly ?? false;
    this.withStack = options?.withStack ?? false;
    this.prefix = options?.prefix ?? '';
  }
  private notRecorded(...args: NzSafeAny[]): boolean {
    const asRecord = args.reduce((acc, c) => acc + c.toString(), '');
    if (this.record[asRecord]) {
      return false;
    } else {
      this.record[asRecord] = true;
      return true;
    }
  }

  private log(level: ILogLevel, ...args: NzSafeAny[]) {
    if (this.devOnly && !isDevMode()) return;
    const msg: NzSafeAny[] = args;
    if (this.withStack) {
      msg.push(new Error().stack);
    }
    if (this.onceOnly) {
      if (this.notRecorded([level, ...args])) {
        console[level](this.prefix, ...args);
      }
    } else {
      console[level](this.prefix, ...args);
    }
  }

  error(...args: NzSafeAny[]) {
    this.log('error', ...args);
  }
  warn(...args: NzSafeAny[]) {
    this.log('warn', ...args);
  }
  info(...args: NzSafeAny[]) {
    this.log('info', ...args);
  }
}
